export default __webpack_public_path__ + "static/media/headhunting_5.e27ebce2.png";